
<!-- <div class="spinner-container" *ngIf="!loaded">
    <mat-spinner class="content-box"></mat-spinner>
</div> -->

<!-- <mat-card appearance="outlined" class="mat-elevation-z8" [ngClass]="{'invisible': !loaded, 'visible': loaded }"> -->
    <mat-card appearance="outlined" class="mat-elevation-z8">
        
    <div class="container">
        <div class="row">
            <mat-tab-group class="col" (selectedTabChange)="onTabChange($event)" animationDuration="0ms">
                
                <!-- registered company users -->
                <mat-tab>
                    <ng-template mat-tab-label class="mat-mdc-tab-label-container">
                        <cqes-icon icon="done"></cqes-icon>
                        {{'reportsTabTexts.registeredCompanyUsers' | translate}}
                    </ng-template>
                    <mat-card >
                        <cloud-business-registered-company-users class="col-12" (isDataLoaded)="loadedData($event)">

                        </cloud-business-registered-company-users>
                    </mat-card>
                </mat-tab>

                <!-- second tab -->
                <!-- <mat-tab>
                    <ng-template mat-tab-label>
                        <cqes-icon icon="done"></cqes-icon>
                     Comming soon
                    </ng-template>
                    <mat-card *ngIf="hasSecondTabBeenSelected">
                        ffff
                    </mat-card>
                </mat-tab> -->

            </mat-tab-group>
        </div>
    </div>
</mat-card>
